import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=7a2ad65d&scoped=true"
import script from "./PageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=7a2ad65d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2ad65d",
  null
  
)

export default component.exports